<div class="container">
  <div class="thanking-popup">
    <div class="shape">
      <img
        class="popup_shape"
        src="https://res.cloudinary.com/dichgutd0/image/upload/v1720000910/EL-Core-Assets/Static/unsubscribe_mz34bt.png"
        alt="popup-image"
      />
    </div>
    <h1 class="thanking-popup__topic el-font-popup-heading">
      {{ title }}
    </h1>
    <p class="thanking-popup__paragraph el-font-popup-sub-heading">
      <a [href]="'mailto:' + email">{{ email }}</a> {{ subtitle }}
    </p>
    <el-button
      name="Subscribe"
      class="thanking-popup__return-btn"
      [isFilled]="true"
      innerClass="thanking-popup__button"
      [isFocusEnabled]="false"
      [isReverseButtonEnabled]="false"
      [isArrowHide]="true"
      (click)="onClick()"
    ></el-button>
  </div>
</div>
